module.exports = __webpack_public_path__ + "static/media/logo.8adcc3d8.svg";